import {
  /* useCallback, */ useCallback,
  useEffect,
  useId,
  useRef,
  useState,
} from "react";
import {
  Container,
  SearchBarSection,
  SearchBarSectionSubcontainer,
} from "./styles";
import SearchBar from "../../../../../components/ui-v2/Inputs/Search";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import DropdownFilter from "../../../../../components/ui-v2/DropdownFilter";
import {
  /* Table , */ TCellNotTagMiscellaneous,
  TCellStyleVariants,
  TTableBody,
  TText,
} from "../../../../../components/ui-v2/TableGrid";
import {
  breakStringPreserveSpaces,
  cnpjMask,
} from "../../../../../utils/formatters";
import {
  TInvoice,
  TInvoiceEntryStatus,
  TInvoiceManifestastionStatus,
  TPaymentSlip,
  setAttachedPaymentSlips,
  setInvoicesUpdatedAt,
  setPaymentSlipsUpdatedAt,
  setToastState,
} from "../../../../../redux/reducers/globalState";
import { useTypedDispatch } from "../../../../../hooks/useTypedDispatch";
import {
  fetchInvoices,
  fetchModalInvoices,
  fetchPaymentSlips,
} from "../../../../../redux/actions";
import {
  CALENDAR_CONTENT_OPTIONS,
  TCalendarMenuOptions,
} from "../../../../../components/ui-v2/DropdownFilter/Menu";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import {
  getQuerystringParams,
  handleParseToDateCalendarOptions,
  handleRevertTranslateCalendarOptions,
  handleSetDataToLocalStorage,
  handleSetEndDate,
  handleTranslateCalendarOptions,
  TQuerystringParams,
} from "../../../../../utils/miscellaneous";
import { localStorageConstants } from "../../../../../utils/constants";
import TableGrid from "../../../../../components/ui-v2/TableGrid";
import apiService from "../../../../../services/api";
import { useNavigationManager } from "../../../../../hooks/useNavigationManager";
import { TButtonIconVariants, TButtonProps } from "../../../Button";
import { UilAngleDown, UilCopyAlt } from "@iconscout/react-unicons";
import AttachmentMenu from "../../../Menus/AttachmentMenu";
import { ROUTES } from "../../../../../router";
import Modal from "../..";
import Tooltip from "../../../Tooltip";
import axios, { CancelTokenSource } from "axios";
import { parseISO } from "date-fns/parseISO";

export type TLinkInvoiceProps = {
  footer: {
    text?: TText[];
    buttons: TButtonProps<TButtonIconVariants>[];
  };
  onClear: (clearFunction: () => void) => void;
};

const LinkInvoice: React.FC<TLinkInvoiceProps> = ({ footer, onClear }) => {
  const dispatch = useTypedDispatch();
  const { goTo, setQuerystring } = useNavigationManager();
  const cancelTokenSource = useRef<CancelTokenSource | null>(null);

  const prevQueryStringsRef = useRef<TQuerystringParams | null>(null);

  const {
    modalInvoiceState,
    selectOrganization,
    selectedOrganizationWithPermissions,
    attachedPaymentSlips,
  } = useTypedSelector((state) => state.globalState.data);

  const isLoading = useTypedSelector(
    (state) => state.globalState.isLoadingModalInvoices
  );

  const startDateRef = useRef<string | undefined>();
  const endDateRef = useRef<string | undefined>();
  const entryStatusRef = useRef<TInvoiceEntryStatus | undefined>(10);
  const payablesRef = useRef<boolean | undefined>();
  const goodsEntryRef = useRef<boolean | undefined>();
  const pageRef = useRef(1);
  const itemsPerPageRef = useRef(100);
  const searchRef = useRef<string | undefined>();
  const allInvoicesRef = useRef<TInvoice[]>([]);
  const searchBarContainerId = useId();

  // Add refs for filter state and setSelected
  const entryStatusFilterRef = useRef<string[]>([]);
  const entryStatusSetSelectedRef = useRef<React.Dispatch<
    React.SetStateAction<string[]>
  > | null>(null);

  const [selectedInvoiceRows, setSelectedInvoiceRows] = useState<TInvoice[]>(
    []
  );

  const [paymentSlipToBreakLink, setPaymentSlipToBreakLink] = useState<
    | {
        target: TPaymentSlip;
        origin: TInvoice;
      }
    | undefined
  >();

  const [shouldShowAttachmentMenu, setShouldShowAttachmentMenu] = useState("");

  const [shouldUpdateComponent, setShouldUpdateComponent] = useState(false);
  const [shouldRejectFilledEntryStatus /* setShouldRejectFilledEntryStatus */] =
    useState(false);
  const entryStatusOptions = [
    "Sem lançamentos",
    "Contas a pagar lançada",
    "Entrada de mercadorias lançada",
  ];

  const [selectedUUIDs, setSelectedUUIDs] = useState<string[]>([]);
  
  const handleFormatStatusCell = (
    status: TInvoiceManifestastionStatus | null
  ) => {
    switch (status) {
      case 10:
        return { style: "blue", value: "Ciente", icon: "noIcon" };
      case 20:
        return { style: "green", value: "Confirmada", icon: "noIcon" };
      case 30:
        return { style: "gray", value: "Desconhecida", icon: "noIcon" };
      case 40:
        return { style: "red", value: "Recusada", icon: "noIcon" };
      case null:
        return { style: "default", value: " - " };
    }
  };

  const rowFormatter = (invoice: TInvoice, index: number) => {
    return [
      { style: "default", value: invoice.number ? invoice?.number : "-" },
      {
        style: "default",
        value: invoice.date_issue
          ? format(parseISO(invoice?.date_issue), "dd/MM/yyyy")
          : "-",
      },
      {
        style: "miscellaneous",
        tooltip: invoice.issuer.name && {
          text: (() => {
            const values = breakStringPreserveSpaces(invoice.issuer.name, 24);

            return values.map((value, index) => ({
              style: "default",
              text: value,
              shouldBreakLine: index !== values.length - 1,
            }));
          })(),
          customTopPosition: index * 96 + 85,
          hasScrollableRef: true,
        },
        values: [
          {
            style: "bold",
            text: invoice.issuer.name
              ? invoice?.issuer.name.length > 20
                ? invoice.issuer.name.slice(0, 20) + "..."
                : invoice.issuer.name
              : "-",
            shouldBreakLine: true,
          },
          {
            style: "default",
            text: invoice.issuer.document_number
              ? cnpjMask(invoice?.issuer.document_number)
              : "-",
            shouldBreakLine: false,
          },
        ],
      },
      {
        style: "default",
        value: invoice.amount ? "R$ " + invoice?.amount.replace(".", ",") : "-",
      },
      handleFormatStatusCell(invoice?.manifestation),
    ] as TTableBody<TCellStyleVariants>[];
  };

  const handleSecondRowLeftSideCustomNodeRender = (
    invoice: TInvoice,
    _index: number
  ) => {
    return (
      <span>
        <Tooltip
          text={[{ text: "Copiar", style: "default", shouldBreakLine: false }]}
        >
          <button
            role="button"
            onClick={() => {
              navigator.clipboard.writeText(invoice.access_key).then(() => {
                dispatch(
                  setToastState({
                    variant: "success",
                    message: {
                      title: "Sucesso",
                      description: "Chave de acesso copiada",
                    },
                    shouldShow: true,
                  })
                );
              });
            }}
          >
            <UilCopyAlt />
          </button>
        </Tooltip>
      </span>
    );
  };

  const handleSecondRowRightSideCustomNodeRender = (
    invoice: TInvoice,
    rowIndex: number
  ) => {
    return invoice.boletos_exists ? (
      <span>
        <button
          role="button"
          onClick={() => {
            apiService
              .getInvoiceAttachedPaymentSlips(
                invoice.uuid,
                (cancelTokenSource.current as CancelTokenSource).token
              )
              .then((response: any) => {
                dispatch(setAttachedPaymentSlips(response.data));
                setShouldShowAttachmentMenu(`${rowIndex}`);
              });
          }}
        >
          Ver boletos <UilAngleDown />
        </button>

        <AttachmentMenu
          position={{ top: 214 + 100 * rowIndex - 3 * rowIndex + "px" }}
          shouldShowMenu={
            shouldShowAttachmentMenu === `${rowIndex}` &&
            attachedPaymentSlips.length > 0
          }
          onClickAway={() => {
            setShouldShowAttachmentMenu("");
          }}
          items={attachedPaymentSlips.map((paymentSlip: TPaymentSlip) => {
            return {
              onDelete:
                paymentSlip.fintera_id && paymentSlip.fintera_id.length > 0
                  ? undefined
                  : () => {
                      setPaymentSlipToBreakLink({
                        target: paymentSlip,
                        origin: invoice,
                      });
                    },
              name: paymentSlip.label,
              searchParam: paymentSlip.bar_code,
              url: ROUTES.PAYMENT_SLIP + window.location.search + "&period=all",
            };
          })}
        />
      </span>
    ) : (
      <span>
        <p>Nenhum boleto vinculado</p>
        {/* <button
          role="button"
          onClick={() => {
            setInvoiceToAttachLinks(invoice);
            setShouldOpenLinkPaymentSlipModal(true);
          }}
        >
          <UilLink />
          &nbsp;Vincular
        </button> */}
      </span>
    );
  };

  const secondRowFormatter = (invoice: TInvoice) => ({
    style: "miscellaneous",
    values: [
      {
        style: "default",
        text: "Chave de acesso: ",
        shouldBreakLine: false,
      },
      {
        style: "faded",
        text: invoice.access_key,
        shouldBreakLine: false,
      },
    ],
  });

  const handleCalendarOnClear = () => {
    const querystring = getQuerystringParams();

    startDateRef.current = undefined;
    endDateRef.current = undefined;
    delete querystring.start_date;
    delete querystring.end_date;
    querystring.period = "all";

    setQuerystring(querystring);

    updateAllInvoicesRef();
  };

  const handleCalendarOnSelect = (selected: string[]) => {
    const select = selected as TCalendarMenuOptions[];
    const querystring = { ...getQuerystringParams() };
    if (CALENDAR_CONTENT_OPTIONS.includes(select[0])) {
      const tempStartDate = handleParseToDateCalendarOptions(select[0]);
      if (tempStartDate === undefined) {
        startDateRef.current = undefined;
        endDateRef.current = undefined;
        delete querystring.start_date;
        delete querystring.end_date;
        querystring.period = "all";

        if (querystring.page) {
          querystring.page = 1;
        }

        setQuerystring(querystring);
        setTimeout(() => {
          updateAllInvoicesRef();
        }, 100);
      } else {
        const formatTempStartDate = format(tempStartDate, "yyyy-MM-dd");
        if (formatTempStartDate !== startDateRef.current) {
          const formatEndDate = handleSetEndDate(select[0]);
          startDateRef.current = formatTempStartDate;
          endDateRef.current = formatEndDate;
          querystring.period = handleTranslateCalendarOptions(
            select[0] as TCalendarMenuOptions
          ) as string;
          delete querystring.start_date;
          delete querystring.end_date;

          if (querystring.page) {
            querystring.page = 1;
          }

          setQuerystring(querystring);
          setTimeout(() => {
            updateAllInvoicesRef();
          }, 100);
        }
      }
    } else {
      const dates = select[0].split(" - ");

      const parsedStart =
        dates[0] && typeof dates[0] === "string"
          ? parse(dates[0], "dd/MM/yyyy", new Date())
          : undefined;
      const tempStartDate =
        parsedStart && !isNaN(parsedStart.getTime())
          ? format(parsedStart, "yyyy-MM-dd")
          : "";

      const parsedEnd =
        dates[1] && typeof dates[1] === "string"
          ? parse(dates[1], "dd/MM/yyyy", new Date())
          : undefined;
      const tempEndDate =
        parsedEnd && !isNaN(parsedEnd.getTime())
          ? format(parsedEnd, "yyyy-MM-dd")
          : "";

      if (tempStartDate !== startDateRef.current)
        startDateRef.current = tempStartDate;
      if (tempEndDate !== endDateRef.current) endDateRef.current = tempEndDate;
      querystring.end_date = tempEndDate;
      querystring.start_date = tempStartDate;
      querystring.period = undefined;

      if (querystring.page) {
        querystring.page = 1;
      }

      setQuerystring(querystring);
      setTimeout(() => {
        updateAllInvoicesRef();
      }, 100);
    }
  };

  const handleEntryStatusCustomFilter = (
    index: string,
    _selected: string[],
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
    selectDataRef: React.MutableRefObject<string[]>,
    prevSelectDataRef: React.MutableRefObject<string[]>,
    setShouldUpdate: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    // Store setSelected for use in onCancel
    entryStatusSetSelectedRef.current = setSelected;

    let currentSelection = entryStatusFilterRef.current;
    prevSelectDataRef.current = [...currentSelection];

    let newSelection: string[] = [];
    if (currentSelection.includes(index)) {
      // Deselect: remove only the clicked index
      newSelection = currentSelection.filter((v) => v !== index);
    } else if (index === "0") {
      // Selecting '0' makes it exclusive
      newSelection = ["0"];
    } else {
      // Add index, but remove '0' if present
      newSelection = currentSelection.filter((v) => v !== "0");
      newSelection.push(index);
    }
    // Ensure only unique values and no empty strings
    newSelection = Array.from(new Set(newSelection)).filter((v) => v !== "");
    entryStatusFilterRef.current = newSelection;
    selectDataRef.current = newSelection;
    setSelected(newSelection);
    setShouldUpdate(true);
    setTimeout(() => setShouldUpdate(false), 20);
  };

    const handleEntryStatusOnClear = () => {
    const queryStrings = getQuerystringParams();

    payablesRef.current = undefined;
    goodsEntryRef.current = undefined;

    delete queryStrings.has_payable_accounts;
    delete queryStrings.has_goods_receipt;

    if (entryStatusRef.current) {
      queryStrings.launch_status = entryStatusRef.current ?? 40;
    }

    if (queryStrings.page) {
      queryStrings.page = 1;
    }

    if (queryStrings.modal) {
      delete queryStrings.modal;
    }

    setQuerystring(queryStrings);

    updateAllInvoicesRef();
  };

  const handleEntryStatusOnAction = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    let hasPayable, hasGoods;
    // Sync ref state
    selectDataRef.current = entryStatusFilterRef.current;

    // Use a copy of the querystring object
    const queryStrings = { ...getQuerystringParams() };

    if (selectDataRef.current.length) {
      if (selectDataRef.current.includes("2")) {
        hasGoods = true;
      }
      if (selectDataRef.current.includes("1")) {
        hasPayable = true;
      }
      if (
        selectDataRef.current.includes("0") &&
        selectDataRef.current.length === 1
      ) {
        hasPayable = false;
        hasGoods = false;
      }
      payablesRef.current = hasPayable;
      goodsEntryRef.current = hasGoods;

      queryStrings.has_payable_accounts = payablesRef.current;
      queryStrings.has_goods_receipt = goodsEntryRef.current;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      setQuerystring(queryStrings);
    } else {
      payablesRef.current = undefined;
      goodsEntryRef.current = undefined;

      delete queryStrings.has_payable_accounts;
      delete queryStrings.has_goods_receipt;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      }

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      setQuerystring(queryStrings);
    }
    updateAllInvoicesRef();
  };

  const handleEntryStatusOnCancel = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    const reset = getDefaultEntryStatusOptions(getQuerystringParams()) || [];
    entryStatusFilterRef.current = reset;
    selectDataRef.current = reset;
    // Use setSelected from ref if available
    setTimeout(() => {
      if (entryStatusSetSelectedRef.current) {
        entryStatusSetSelectedRef.current(reset);
      }
    }, 200);
    // Optionally reset payablesRef, goodsEntryRef, etc. if needed
  };

  const getDefaultEntryStatusOptions = (queryStrings: TQuerystringParams) => {
    const hasPayableCondition = queryStrings.has_payable_accounts;
    const hasGoodsCondition = queryStrings.has_goods_receipt;
    const hasNotEntryCondition =
      hasPayableCondition === false && hasGoodsCondition === false;

    if (hasNotEntryCondition) return ["0"];
    if (hasPayableCondition && hasGoodsCondition) return ["1", "2"];
    if (hasPayableCondition) return ["1"];
    if (hasGoodsCondition) return ["2"];
    return undefined;
  };

  const fetchPaymentSlipsByAllEntryStatus = async () => {
    if (selectOrganization) {
      setShouldUpdateComponent(true);
      setTimeout(async () => {
        if (cancelTokenSource.current)
          await dispatch(
            fetchPaymentSlips({
              cancelToken: cancelTokenSource.current.token,
            })
          )
            .unwrap()
            .then(() => {
              apiService
                .getPaymentSlipUpdatedAt(
                  selectOrganization.uuid,
                  (cancelTokenSource.current as CancelTokenSource).token
                )
                .then((response) => {
                  if (response) {
                    dispatch(
                      setPaymentSlipsUpdatedAt({
                        responseStatus: response.status,
                        date: response.data.updated_at,
                      })
                    );
                  }
                });
            });
        setShouldUpdateComponent(false);
      }, 50);
    }
  };

  const fetchInvoicesByAllEntryStatus = async (_endDate?: string) => {
    if (selectOrganization) {
      setTimeout(() => {
        if (cancelTokenSource.current)
          dispatch(
            fetchInvoices({
              cancelToken: cancelTokenSource.current.token,
            })
          )
            .unwrap()
            .then(() => {
              apiService
                .getInvoiceUpdatedAt(
                  selectOrganization.uuid,
                  (cancelTokenSource.current as CancelTokenSource).token
                )
                .then((response) => {
                  dispatch(
                    setInvoicesUpdatedAt({
                      responseStatus: response.status,
                      date: response.data.updated_at,
                    })
                  );
                });
            });
      }, 50);
    }
  };

  entryStatusFilterRef.current =
    getDefaultEntryStatusOptions(getQuerystringParams()) || [];

  // Pure function for default entry status options
  const handleEntryStatusForceSelectOptions = () => {
    const result = getDefaultEntryStatusOptions({ ...getQuerystringParams() });

    return result;
  };

  const handlePeriodForceSelectOptions = () => {
    const queryStrings = getQuerystringParams();

    if (queryStrings.start_date && queryStrings.end_date) {
      startDateRef.current = queryStrings.start_date[0];
      endDateRef.current = queryStrings.end_date[0];

      return [
        queryStrings.start_date[0].replace(
          /(\d{4})-(\d{2})-(\d{2})/,
          "$3/$2/$1"
        ),
        queryStrings.end_date[0].replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1"),
      ];
    }

    const calendarOptions = [
      ...CALENDAR_CONTENT_OPTIONS.map((string) => string.toLowerCase()),
    ];

    if (
      queryStrings.period &&
      calendarOptions.includes(
        handleRevertTranslateCalendarOptions(
          queryStrings.period[0] as TCalendarMenuOptions
        ) as string
      )
    ) {
      return [
        calendarOptions.indexOf(
          handleRevertTranslateCalendarOptions(
            queryStrings.period[0] as TCalendarMenuOptions
          ) as string
        ),
      ];
    }

    return undefined;
  };

  const handleSelect = (selected: { elementId: string }[]) => {
    // Defensive: Only use valid UUIDs
    const uuids = selected
      .map((el) => el.elementId)
      .filter((id) => typeof id === "string" && id.length > 0);

    // Handle "all" and "none" selection
    if (uuids.length === 1 && uuids[0] === "all") {
      setSelectedUUIDs(modalInvoiceState.results.map((inv) => inv.uuid));
    } else if (uuids.length === 1 && uuids[0] === "none") {
      setSelectedUUIDs([]);
    } else {
      setSelectedUUIDs(uuids);
    }
  };

  const updateAllInvoicesRef = useCallback(
    async (_entryStatus?: number) => {
      cancelTokenSource.current = axios.CancelToken.source();
      const queryStringParams = getQuerystringParams();

      endDateRef.current = queryStringParams.end_date;
      startDateRef.current = queryStringParams.start_date;
      payablesRef.current = queryStringParams.has_payable_accounts;
      goodsEntryRef.current = queryStringParams.has_goods_receipt;
      pageRef.current = queryStringParams.page;
      itemsPerPageRef.current = queryStringParams.items_per_page;
      entryStatusRef.current = queryStringParams.launch_status as
        | TInvoiceEntryStatus
        | undefined;

      await dispatch(
        fetchModalInvoices({ cancelToken: cancelTokenSource.current.token })
      )
        .unwrap()
        .then(async (response) => {
          allInvoicesRef.current = response?.results;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    [window.location.search]
  );

  useEffect(() => {
    // Always copy before mutating to avoid read-only errors
    const queryStrings = { ...getQuerystringParams() };

    prevQueryStringsRef.current = { ...queryStrings };

    queryStrings.modal = true;
    delete queryStrings.start_date;
    delete queryStrings.end_date;
    queryStrings.period = "all";
    setQuerystring(queryStrings);

    updateAllInvoicesRef();
    return () => {
      if (prevQueryStringsRef.current) {
        setQuerystring(prevQueryStringsRef.current);
        goTo(window.location.pathname, prevQueryStringsRef.current);
      }

      if (cancelTokenSource.current) cancelTokenSource.current.cancel();
    };
  }, []);

  useEffect(() => {
    onClear(() => {
      setSelectedInvoiceRows([]);
      setShouldUpdateComponent(true);
      setTimeout(() => {
        setShouldUpdateComponent(false);
      }, 100);
    });
  }, [modalInvoiceState, selectedOrganizationWithPermissions]);

  useEffect(() => {
    // Sync selectedInvoiceRows whenever modalInvoiceState.results or selectedUUIDs changes
    if (modalInvoiceState?.results) {
      setSelectedInvoiceRows(
        modalInvoiceState.results.filter((invoice) =>
          selectedUUIDs.includes(invoice.uuid)
        )
      );
    }
  }, [modalInvoiceState?.results, selectedUUIDs]);

  return (
    <Container data-testid="link-invoice-modal">
      <SearchBarSection>
        <SearchBar
          onClear={() => {
            searchRef.current = undefined;

            const queryStrings = getQuerystringParams();

            delete queryStrings.link_invoices_search;
            if (entryStatusRef.current) {
              queryStrings.launch_status = entryStatusRef.current ?? 40;
            }
            setQuerystring(queryStrings);

            if (cancelTokenSource.current) {
              dispatch(
                fetchModalInvoices({
                  cancelToken: cancelTokenSource.current.token,
                })
              );
            }
          }}
          onSearch={(searchPhrase) => {
            searchRef.current = searchPhrase;

            const queryStrings = getQuerystringParams();

            if (searchRef.current && searchRef.current.length > 0) {
              queryStrings.link_invoices_search = searchRef.current;
            } else {
              delete queryStrings.link_invoices_search;
            }
            if (entryStatusRef.current) {
              queryStrings.launch_status = entryStatusRef.current ?? 40;
            }

            if (queryStrings.page) {
              queryStrings.page = 1;
            }

            setQuerystring(queryStrings);

            if (cancelTokenSource.current) {
              dispatch(
                fetchModalInvoices({
                  cancelToken: cancelTokenSource.current.token,
                })
              );
            }
          }}
          variant="default"
          placeholder="Buscar por NF-e ou Emitente"
        />
        <SearchBarSectionSubcontainer id={searchBarContainerId}>
          <DropdownFilter
            buttonVariant="calendar"
            menuVariant="calendar"
            onSelect={handleCalendarOnSelect}
            forceSelectOptionsByIndex={(() => {
              const result = handlePeriodForceSelectOptions();
              return shouldRejectFilledEntryStatus ||
                (result && typeof result[0] === "string")
                ? []
                : (result as number[]);
            })()}
            filled={(() => {
              const result = handlePeriodForceSelectOptions();

              return result === undefined
                ? result
                : typeof result[0] === "string"
                ? (result as string[])
                : [CALENDAR_CONTENT_OPTIONS[result[0]]];
            })()}
            onClear={handleCalendarOnClear}
          />
          <DropdownFilter
            buttonVariant="checkCircle"
            placeholder="Lançamentos"
            content={entryStatusOptions}
            menuVariant="unlabeled"
            search={false}
            customFilter={handleEntryStatusCustomFilter}
            onAction={handleEntryStatusOnAction}
            onClear={handleEntryStatusOnClear}
            onCancel={handleEntryStatusOnCancel}
            hasBottomBar
            key={
              getQuerystringParams().has_payable_accounts +
              "" +
              getQuerystringParams().has_goods_receipt
            }
            forceSelectOptionsByIndex={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return shouldRejectFilledEntryStatus
                ? undefined
                : result
                ? result.map(Number)
                : undefined;
            })()}
            filled={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return result === undefined
                ? result
                : [...result.toString().replaceAll(",", "")];
            })()}
          />
        </SearchBarSectionSubcontainer>
      </SearchBarSection>

      {modalInvoiceState && (
        <TableGrid
          data-testid="link-invoice-tablegrid"
          key={shouldUpdateComponent + "-invoices-tablegrid"}
          row="doubleRow"
          disableBatchOperations
          columns={{
            tableHead: {
              // 24px 80px 150px 200px 240px 200px 160px
              width: [`24px 80px 150px 200px 240px 200px 160px`],
            },
            tableBody: {
              width: [`24px 80px 150px 200px 240px 200px 160px`],
            },
          }}
          onSelect={handleSelect}
          onAction={() => {
            window.location.reload();
          }}
          emptyState={{
            isEmptyState: !isLoading && modalInvoiceState?.results.length === 0,
            title: "Nenhuma nota encontrada",
            description: "Altere os filtros e realize a busca novamente",
          }}
          secondRow={{
            params: modalInvoiceState?.results.map((invoice, index) => ({
              data: {
                ...(secondRowFormatter(invoice) as TCellNotTagMiscellaneous),
                skeleton: isLoading
                  ? {
                      containerCss: {
                        display: "flex",
                        justifyContent: "space-between",
                        width: "1005px",
                        margin: "0 20px",
                      },
                      values: [
                        { width: "216px", height: "16px" },
                        {
                          width: "96px",
                          height: "16px",
                          style: { maxWidth: "96px", overflow: "hidden" },
                        },
                      ],
                    }
                  : undefined,
              },
              leftSideCustomNode: !isLoading && (
                <>{handleSecondRowLeftSideCustomNodeRender(invoice, index)}</>
              ),
              rightSideCustomNode: !isLoading && (
                <>{handleSecondRowRightSideCustomNodeRender(invoice, index)}</>
              ),
            })),
          }}
          selectType={{ type: "multiSelect", fullData: allInvoicesRef.current }}
          tableHead={{
            value: [
              { style: "noIcon", showSkeleton: isLoading, value: "Número" },
              {
                style: "noIcon",
                showSkeleton: isLoading,
                value: "Data emissão",
              },
              { style: "noIcon", showSkeleton: isLoading, value: "Emitente" },
              { style: "noIcon", showSkeleton: isLoading, value: "Valor" },
              {
                style: "noIcon",
                showSkeleton: isLoading,

                value: "Status manifestação",
              },
            ],
          }}
          isLoading={isLoading}
          tableBody={
            isLoading
              ? new Array(5).fill("").map(() => ({
                  elementId: "",
                  file_nfe: null,
                  file_xml: null,
                  body: [
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "72px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "88px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "177px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: { values: [{ width: "100px" }] },
                    },
                    {
                      style: "default",
                      value: "",
                      skeleton: {
                        values: [
                          { width: "120px", style: { overflow: "hidden" } },
                        ],
                      },
                    },
                  ] as TTableBody<TCellStyleVariants>[],
                }))
              : (modalInvoiceState?.results ?? []).map(
                  (invoice: TInvoice, index: number) => ({
                    elementId: invoice.uuid,
                    file_nfe: invoice.file_nfe,
                    file_xml: invoice.file_xml,
                    body: rowFormatter(invoice, index),
                  })
                )
          }
          footer={{
            customStyle: {
              width: "1068px",
            },
            formButtons: {
              buttons: [
                (() => {
                  const cancelButton = { ...footer.buttons[0] };
                  cancelButton.onClick = () => {
                    if (footer.buttons[0].onClick) {
                      footer.buttons[0].onClick();
                      setSelectedInvoiceRows([]);
                      setShouldUpdateComponent(true);
                      setTimeout(() => {
                        setShouldUpdateComponent(false);
                      }, 100);
                    }
                  };
                  return cancelButton;
                })(),
                (() => {
                  const actionButton = { ...footer.buttons[1] };
                  if (selectedInvoiceRows.length === 0) {
                    actionButton.disabled = true;
                    actionButton.text = "Confirmar selecionado";
                  }
                  if (selectedInvoiceRows.length > 0) {
                    actionButton.disabled = false;
                    actionButton.text = "Confirmar selecionado";
                  }
                  if (selectedInvoiceRows.length > 1) {
                    actionButton.text = "Confirmar selecionados";
                  }
                  actionButton.onClick = () => {
                    if (footer.buttons[1].onClick) {
                      footer.buttons[1].onClick({
                        selectedInvoices: selectedInvoiceRows,
                        clearSelectedInvoices: () => {
                          setShouldUpdateComponent(true);
                          setTimeout(() => {
                            setShouldUpdateComponent(false);
                          }, 100);
                        },
                      });
                    }
                  };
                  return actionButton;
                })(),
              ],
            },
            leftSideDescription:
              " | Total de " +
              modalInvoiceState.count +
              (modalInvoiceState.count > 1
                ? " registros encontrados"
                : " registro encontrado"),
            onSelectItemsPerPage(amount) {
              const queryStrings = getQuerystringParams();
              pageRef.current = 1;
              queryStrings.page = pageRef.current;
              queryStrings.items_per_page = amount;
              setQuerystring(queryStrings);
              goTo(window.location.pathname, queryStrings);
              if (/* selectOrganization &&  */ cancelTokenSource.current) {
                dispatch(
                  fetchInvoices({
                    cancelToken: cancelTokenSource.current.token,
                  })
                );
              }
            },
            customPagination: modalInvoiceState
              ? {
                  fixedBottom: { isFixedAtTheBottom: true },
                  currentPage: `${modalInvoiceState?.current_page}`,
                  buttonBackward: {
                    disabled: modalInvoiceState.current_page === 1,
                    onClick() {
                      pageRef.current = modalInvoiceState.current_page - 1;
                      const queryStrings = getQuerystringParams();
                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }
                      handleSetDataToLocalStorage(
                        localStorageConstants.CURRENT_PAGE,
                        pageRef.current
                      );
                      if (
                        selectOrganization &&
                        modalInvoiceState.current_page !== 1 &&
                        cancelTokenSource.current
                      ) {
                        queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);
                        goTo(window.location.pathname, queryStrings);
                        dispatch(
                          fetchInvoices({
                            cancelToken: cancelTokenSource.current.token,
                          })
                        );
                      }
                    },
                  },
                  buttonForward: {
                    disabled:
                      modalInvoiceState.current_page ===
                      modalInvoiceState.pages.length,
                    onClick() {
                      if (
                        modalInvoiceState.current_page ===
                        modalInvoiceState.pages.length
                      ) {
                        pageRef.current = modalInvoiceState.current_page;
                      } else {
                        pageRef.current = modalInvoiceState.current_page + 1;
                      }
                      const queryStrings = getQuerystringParams();
                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }
                      handleSetDataToLocalStorage(
                        localStorageConstants.CURRENT_PAGE,
                        pageRef.current
                      );
                      if (
                        selectOrganization &&
                        modalInvoiceState.current_page !==
                          modalInvoiceState.pages.length &&
                        cancelTokenSource.current
                      ) {
                        queryStrings.page = pageRef.current;
                        setQuerystring(queryStrings);
                        setQuerystring(queryStrings);
                        goTo(window.location.pathname, queryStrings);
                        dispatch(
                          fetchInvoices({
                            cancelToken: cancelTokenSource.current.token,
                          })
                        );
                      }
                    },
                  },
                  pages: modalInvoiceState.pages.map((page) => {
                    return {
                      value: Object.keys(page)[0],
                      onClick() {
                        let temp =
                          Object.values(page)[0].match(/.*?page=(\d+)&per_/);
                        if (temp !== null && temp[1]) {
                          pageRef.current = parseInt(temp[1]);
                        } else {
                          pageRef.current = 1;
                        }
                        const queryStrings = getQuerystringParams();
                        if (queryStrings.items_per_page) {
                          itemsPerPageRef.current = queryStrings.items_per_page;
                        }
                        handleSetDataToLocalStorage(
                          localStorageConstants.CURRENT_PAGE,
                          pageRef.current
                        );
                        if (selectOrganization && cancelTokenSource.current) {
                          queryStrings.page = pageRef.current;
                          setQuerystring(queryStrings);
                          goTo(window.location.pathname, queryStrings);
                          dispatch(
                            fetchInvoices({
                              cancelToken: cancelTokenSource.current.token,
                            })
                          );
                        }
                      },
                    };
                  }),
                }
              : undefined,
          }}
        />
      )}

      <Modal
        key={paymentSlipToBreakLink?.target.uuid}
        title="Remover vínculo"
        icon={{ type: "breakLink", color: "red" }}
        main={{
          style: "textOnly",
          content: [
            {
              text: "Tem certeza que deseja remover o vínculo com este boleto?",
              style: "default",
              shouldBreakLine: false,
            },
          ],
        }}
        footer={{
          style: "default",
          buttons: [
            {
              variant: "secondary",
              icon: "noIcon",
              text: "Cancelar",
              onClick() {
                setPaymentSlipToBreakLink(undefined);
              },
            },
            {
              variant: "red",
              iconPosition: "left",
              icon: "checkmark",
              text: "Sim, remover",
              onClick() {
                if (paymentSlipToBreakLink) {
                  apiService
                    .detachPaymentSlipFromInvoice(
                      paymentSlipToBreakLink.origin.uuid,
                      paymentSlipToBreakLink.target.uuid,
                      (cancelTokenSource.current as CancelTokenSource).token
                    )
                    .then(() => {
                      setPaymentSlipToBreakLink(undefined);
                      dispatch(
                        setToastState({
                          variant: "success",
                          shouldShow: true,
                          message: {
                            title: "Sucesso",
                            description: "Vínculo removido",
                          },
                        })
                      );
                      fetchInvoicesByAllEntryStatus();
                      fetchPaymentSlipsByAllEntryStatus();
                    })
                    .catch(() => {
                      setPaymentSlipToBreakLink(undefined);
                      dispatch(
                        setToastState({
                          variant: "error",
                          shouldShow: true,
                          message: {
                            title: "Erro",
                            description:
                              "Não foi possível remover o vínculo, tente novamente",
                          },
                        })
                      );
                    });
                }
              },
            },
          ],
        }}
        shouldOpen={paymentSlipToBreakLink !== undefined}
        onClose={() => {
          setPaymentSlipToBreakLink(undefined);
        }}
      />
    </Container>
  );
};

export default LinkInvoice;
